<template lang="html">
    <div class="panel panel-default">

        <div class="panel-heading">
          <h5 class="dash-control-title text-center">
              {{ title }}
          </h5>
        </div>

        <div class="panel-body text-center">

          <button class="btn btn-xs btn-success" v-if="!this.buckets.length" @click="addDefaultBucket()">
            <i class="fas fa-plus"></i>
            Add Bucket
          </button>

          <bucket v-for="(bucket, index) in buckets" :key="bucket.id"
                  :value="bucket"
                  :min="bucket.min"
                  :max="bucket.max"
                  :name="'Bucket '+ (index + 1)"
                  :index="index"
                  :id="bucket.id"></bucket>

        </div>

        <div class="panel-footer">
          <div class="text-muted text-center">
            <i class="fas fa-info-circle"></i>
            <small>{{ info }}</small>
          </div>
        </div>

    </div>
</template>

<script>
import Bucket from '@/components/dashboard/Bucket'

export default {

  name: 'progress-buckets',

  props: ['title', 'info'],

  components: {
    'bucket': Bucket
  },

  data () {
    return {
      buckets: [
        { id: '1', min: 0, max: 20 },
        { id: '2', min: 21, max: 40 },
        { id: '3', min: 41, max: 60 },
        { id: '4', min: 61, max: 80 },
        { id: '5', min: 81, max: 100 }
      ]
    }
  },

  beforeDestroy () {
    // Destroy any listeners
    this.eventHub.$off('bucketAdded')
    this.eventHub.$off('bucketRemoved')
    this.eventHub.$off('bucketUpdated')
  },

  mounted () {
    this.updateProgBuckets()

    /** Handle a Removed Bucket */
    this.eventHub.$on('bucketRemoved', bucketId => {
      // eslint-disable-next-line
      let indexOfBucket = _.findIndex(this.buckets, [ 'id', bucketId ])
      this.buckets.splice(indexOfBucket, 1)
      this.updateProgBuckets()
    })

    /** Handle an Added Bucket */
    this.eventHub.$on('bucketAdded', bucketData => {
      this.buckets.push({
        // eslint-disable-next-line
        id: _.uniqueId('bucket_'),
        min: parseInt(bucketData.min),
        max: parseInt(bucketData.max)
      })
      this.updateProgBuckets()
    })

    /** Handle an Updated Bucket */
    this.eventHub.$on('bucketUpdated', bucketData => {
      // eslint-disable-next-line
      let indexOfBucket = _.findIndex(this.buckets, ['id', bucketData.id])
      this.buckets[indexOfBucket].min = bucketData.min
      this.buckets[indexOfBucket].max = bucketData.max
      this.updateProgBuckets()
    })
  },

  methods: {
    updateProgBuckets () {
      let bucketData = this.buckets.map(bucket => {
        bucket['label'] = `${bucket.min}% - ${bucket.max}%`
        return bucket
      })

      this.$store.commit('setProgBuckets', bucketData)
      this.eventHub.$emit('progBucketsUpdated')
    },

    getData () {
      return this.$store.getters.barGraphData
    },

    addDefaultBucket () {
      this.buckets.push({
        // eslint-disable-next-line
        id: _.uniqueId('bucket_'),
        min: 0,
        max: 100
      })
    }
  }

}
</script>

<style lang="css" scoped>
  input {
    width: 100%;
  }

  .btn.btn-success {
    background-color: RGBA(139, 153, 105, 0.8);
    border: 1px solid RGBA(139, 153, 105, 1.00);
  }

  .input-group input.form-control:not(:last-child) {
    border-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ProgressBuckets.vue